export default __webpack_public_path__ + "static/media/H1016.1.b59beaa8.mp3";